<template>
  <div class="about">

  <div class="overlay"><h1>à propos</h1></div>
  <div class="overlay"><div class="aproposTexte">
    <p><strong>Durant 3 ans j’ai étudié l’informatique</strong>, et je me suis spécialisé dans le développement web au terme d’une licence. À la suite de ce cursus technique, j’ai eu envie de maîtriser le versant créatif des métiers du web. <strong>J’ai obtenu un BTS en design graphique</strong>, spécialisé dans les médias numériques à l’ESMA Montpellier.</p>
    <p>Je crois fondamentalement à la phrase de Daniel Arasse : <strong> « la peinture ça ne montre pas seulement, ça pense ».</strong> C’est un principe qui vaut autant pour le design graphique que pour la peinture. Aussi, je pratique le dessin et l’illustration dès que l’occasion se présente, et je lis autant que possible. <strong>Un bon œil et une pensée rigoureuse nourrissent un bon graphisme.</strong></p>
    <p>Dans la vie, toutes sortes d’objets et de sujets m’enthousiasment : <strong> de la batterie jazz à l’existentialisme, de la culture russe à la bonne bière, des musées des beaux-arts aux concerts de punk, des vieux gréements au café noir.</strong></p>
    <div class="overlay"><div class="cv"><a href="./CV-Nicolas-Noel.pdf"><button>Télécharger mon CURRICULUM VITAE</button></a></div></div>
  </div></div>
</div>
</template>

<script>

export default {
  components: {

  },
  mounted(){
    let revealTlAbout= new TimelineMax()
    revealTlAbout.delay(1.5);
    revealTlAbout.from('.about h1', 1, {
      y: '-100%', opacity:0,
      ease: Expo.easeOut
    });
    revealTlAbout.from('.about .aproposTexte', 1, {
      x: '-10%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
    revealTlAbout.from('.about .cv', 1, {
      y: '100%', opacity:0,
      ease: Expo.easeOut
    }, "-=0.5");
  }
}
</script>


<style scoped>

.about{
padding: 12.5rem 7.5rem 6.25rem 7.5rem;
background-image: url('../assets/portrait-pattern-reversed.png');
background-size: contain;
background-position:  right;
background-repeat: no-repeat;
min-height: 100vh;
}

h1 {
  color: #222;
  font-size: 8rem;
    font-weight: bold;
    padding-bottom: 6.25rem;
}

p{
  margin-bottom: 2.25rem;
  font-size: 1.5rem;
  line-height: 2.25rem;
    color: #222;
}

strong{
  font-weight: bold;
  font-style: italic;
}


button{
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  font-size: 1.5rem;
  text-transform: uppercase;
  color: #555;
        line-height: 2.25rem;
    background-color: #dec8b2;
    width:50%;
    border: none;
    padding: 1rem;
    cursor: pointer;

        transition: 0.3s;
        border: solid 1px #dec8b2;
}

button:hover{
      background-color: #fff;
        color: #dec8b2;
        border: solid 1px #dec8b2;
        transition: 0.3s;
}

.cv{
  text-align: center;
}

@media all and (max-width: 736px) {

  .about{
    padding: 12.5rem 4rem 6.25rem 4rem;

  }

  .aproposTexte p{
    font-size: 2rem;
    line-height: 3rem;
  }

  button{
    width: 100%;
  }
}
</style>
